import api from './index'
import { axios } from '@/utils/request'

export function createBadge(parameter) {
  return axios({
    url: api.BaseURL + api.Badge + 'create',
    method: 'POST',
    data: parameter
  })
}

export function getListBadge(parameter) {
  return axios({
    url: api.BaseURL + api.Badge + 'list',
    method: 'GET',
    params: parameter
  })
}

export function updateBadge(parameter) {
  return axios({
    url: api.BaseURL + api.Badge + 'update',
    method: 'POST',
    data: parameter
  })
}

export function deleteBadge(parameter) {
  return axios({
    url: api.BaseURL + api.Badge + 'delete',
    method: 'POST',
    data: parameter
  })
}